import React from "react";
import FuzzySearch from "fuzzy-search";
import Graph from "../Graph";
import axios from 'axios';

import "./index.scss";

import EmployeeItem from "./EmployeeItem";

class EmployeeList extends React.Component {
  pageNumber = 2
  stopScrollLoading = false
  searchDelayTimer = null
  state = {
    searchBox: "", 
    stateEmployees: []
  };
  constructor(props) {
    super(props);
    //this.setState({stateEmployees : props.employees});
    this.fuzzy_search = new FuzzySearch(this.props.employees, ["name"]);
  }
  onClick = (e, id) => {
    const { selected, updateSelected } = this.props;
    const state = selected[id];
    
    if (e.ctrlKey) updateSelected({ ...selected, [id]: !state });
    else updateSelected({ [id]: !state });
  };
  selectStatus = () => {
    const { employees, selected } = this.props;
    if (Object.keys(selected).length !== employees.length) return "none";
    let toret = selected[Object.keys(selected)[0]] ? "all" : "none";
    Object.keys(selected).forEach(k => {
      const status = selected[k];
      if (status && toret === "none") return "some_selected";
      if (!status && toret === "all") return "some_selected";
    });
    return toret;
  };
  toggleSelectAll = () => {
    const { employees, updateSelected } = this.props;
    const status = this.selectStatus() === "all" ? false : true;
    const selected = employees.reduce((a, e) => {
      a[e.id] = status;
      return a;
    }, {});
    updateSelected(selected);
  };
  scrollCheck = event => {
    if(this.stopScrollLoading)
      return;
    const bottom = event.target.scrollHeight - event.target.scrollTop === event.target.clientHeight;
    if (bottom) {
      let updateEmployees = this.props.updateEmployees;
      axios.get(Graph.baseURL + '/orgchart/GetEmployees?SearchValue=&CompanyID=1&PageSize=50&pageNumber=' + this.pageNumber, {
          headers: {
            'Authorization': Graph.token
          }})
        .then(res => 
        {
          this.pageNumber++;
          if(res.data.result.length > 0){
            let mergedEmployees = Graph.mergeEmployees(res.data.result);
            updateEmployees(mergedEmployees);
            Graph._updateCb();
          }
        });
    }
  };
  search = searchVal => {
    clearTimeout(this.searchDelayTimer);
    this.searchDelayTimer = setTimeout(() => {
      //if searchval is empty load the employees again
      searchVal == '' ? this.stopScrollLoading = false : this.stopScrollLoading = true;

      let updateEmployees = this.props.updateEmployees;
      axios.get(Graph.baseURL + '/orgchart/GetEmployees?CompanyID=1&SearchValue=' + searchVal, {
          headers: {
            'Authorization': Graph.token
          }})
        .then(res => 
        {
          if(res.data.result.length > 0){
            Graph.mergeEmployees(res.data.result);
            updateEmployees(Graph.employeeList);
            Graph._updateCb();
            this.setState({ searchBox: searchVal })
          }
        });
    }, 2000);
  };
  render() {
    const { height, selected } = this.props;
    const { searchBox } = this.state;
    let fuzzy_search = new FuzzySearch(this.props.employees, ["name"]);
    
    const employees_filtered = fuzzy_search.search(searchBox);
    return (
      <div className="EmployeeListContainer" onScroll={this.scrollCheck}>
        <div id="EmployeeListSearchControls">
          <div className="EmployeeListSearchBox">
            <input
              placeholder="Search"
              name="employee_search"
              style={{ width: "100%" }}
              onChange={e => this.search(e.target.value)}
            />
          </div>
          <div className="EmployeeListSelectAll">
            <input
              type="checkbox"
              id="selectAll"
              checked={this.selectStatus() === "all"}
              onChange={this.toggleSelectAll}
            />
            <label className="label-inline" htmlFor="selectAll">
              Select All
            </label>
          </div>
          <div className="EmployeeListTip">Press ctrl to multi select</div>
        </div>
        <div className="EmployeeList" style={{ height }}>
          {employees_filtered.map(function(employee) {return (
            <EmployeeItem
              key={employee.id}
              employee={employee}
              onClick={(e) => this.onClick(e,employee.id)}
              selected={selected}
            />
          );}, this)}
        </div>
      </div>
    );
  }
}

export default EmployeeList;
